export default "__VITE_PUBLIC_ASSET__19480f07__"